import { memo } from 'react'
import { Copy, KeyRound, MapPin, NotebookPen } from 'lucide-react'
import { copyHandler } from '@/utils'
import { WalletItem, WalletSwapper, WalletTitle } from './style'

interface PropsType {
  wallet: { address: string; mnemonic: string; privateKey: string }
  index: number
}

function WalletCard({ wallet, index }: PropsType) {
  const rows = [
    { label: '钱包地址', value: wallet.address, icon: MapPin },
    { label: '助记词', value: wallet.mnemonic, icon: NotebookPen },
    { label: '私钥', value: wallet.privateKey, icon: KeyRound },
  ]

  return (
    <WalletSwapper>
      <WalletTitle><span className="number">{index}</span>钱包 #{index}</WalletTitle>
      {rows.map(({ label, value, icon: Icon }) => (
        <WalletItem key={label}>
          <span className="left"><Icon size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />{label}</span>
          <span className="center">{value}</span>
          <button className="right" type="button" onClick={() => copyHandler(value)}><Copy size={13} />复制</button>
        </WalletItem>
      ))}
    </WalletSwapper>
  )
}

export default memo(WalletCard)
